import React from "react";
import { Link } from "react-router-dom";
import { signInWithGoogle } from "../auth/index";

const AppStoreBadge = () => (
  <a
    href="https://apps.apple.com/no/app/bedrely/id6759217170"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 10,
      background: "#111111",
      color: "#FFFFFF",
      padding: "13px 28px",
      borderRadius: 14,
      border: "1.5px solid #333333",
      textDecoration: "none",
      transition: "border-color 0.2s, transform 0.2s, background 0.2s",
    }}
    onMouseEnter={e => { e.currentTarget.style.borderColor = "#FFFFFF"; e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.background = "#222222"; }}
    onMouseLeave={e => { e.currentTarget.style.borderColor = "#333333"; e.currentTarget.style.transform = ""; e.currentTarget.style.background = "#111111"; }}
  >
    <svg width="26" height="26" viewBox="0 0 24 24" fill="white">
      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
    </svg>
    <div style={{ textAlign: "left" }}>
      <div style={{ fontSize: 10, color: "#999999", lineHeight: 1.2 }}>Download on the</div>
      <div style={{ fontSize: 18, fontWeight: 700, lineHeight: 1.3 }}>App Store</div>
    </div>
  </a>
);

const GooglePlayBadge = () => (
  <a
    href="https://play.google.com/apps/testing/com.bytegarden.bedrely"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 10,
      background: "#111111",
      color: "#FFFFFF",
      padding: "13px 28px",
      borderRadius: 14,
      border: "1.5px solid #333333",
      textDecoration: "none",
      transition: "border-color 0.2s, transform 0.2s, background 0.2s",
    }}
    onMouseEnter={e => { e.currentTarget.style.borderColor = "#FFFFFF"; e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.background = "#222222"; }}
    onMouseLeave={e => { e.currentTarget.style.borderColor = "#333333"; e.currentTarget.style.transform = ""; e.currentTarget.style.background = "#111111"; }}
  >
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
      <path d="M3.18 23.76c.3.17.64.24.99.2L15.34 12 11.5 8.16 3.18 23.76z" fill="#EA4335"/>
      <path d="M20.96 10.27L17.7 8.4l-3.7 3.6 3.7 3.6 3.28-1.89c.94-.54.94-1.9-.02-2.44z" fill="#FBBC05"/>
      <path d="M3.18.24C2.86.42 2.64.74 2.64 1.16v21.68c0 .42.22.74.54.92L15.34 12 3.18.24z" fill="#4285F4"/>
      <path d="M3.18 23.76L15.34 12 11.5 8.16 3.18 23.76z" fill="#34A853" opacity=".8"/>
      <path d="M15.34 12L3.18.24c.3-.17.66-.2.99-.04L17.7 8.4 15.34 12z" fill="#34A853"/>
    </svg>
    <div style={{ textAlign: "left" }}>
      <div style={{ fontSize: 10, color: "#999999", lineHeight: 1.2 }}>Try the Beta on</div>
      <div style={{ fontSize: 18, fontWeight: 700, lineHeight: 1.3 }}>Google Play</div>
    </div>
  </a>
);

const PhoneMockup = ({ src, alt, rotate = 0, translateY = 0 }) => (
  <div style={{
    transform: `rotate(${rotate}deg) translateY(${translateY}px)`,
    flexShrink: 0,
    width: 200,
  }}>
    {/* Phone shell */}
    <div style={{
      position: "relative",
      width: 200,
      background: "#0a0a0a",
      borderRadius: 36,
      border: "2px solid #2a2a2a",
      boxShadow: "0 30px 80px rgba(0,0,0,0.8), 0 0 0 1px rgba(255,255,255,0.05), inset 0 0 0 1px rgba(255,255,255,0.03)",
      overflow: "hidden",
      aspectRatio: "9 / 19.5",
    }}>
      {/* Dynamic island */}
      <div style={{
        position: "absolute",
        top: 10,
        left: "50%",
        transform: "translateX(-50%)",
        width: 70,
        height: 22,
        background: "#000000",
        borderRadius: 11,
        zIndex: 10,
      }} />
      {/* Screenshot */}
      <img
        src={src}
        alt={alt}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "top",
          display: "block",
        }}
      />
    </div>
  </div>
);

const LandingPage = () => {
  const features = [
    { icon: "🔎", title: "Find something quick", desc: "Browse short, doable routines by style. Bodyweight at home, weights at the gym, quick intervals or longer flows. No \"advanced\" gating, no equipment lists you can't meet." },
    { icon: "⏱️", title: "A timer that just works", desc: "Sound and vibration cues, live progress for every round, fine in silent mode. We handle the clock so you can put the phone down." },
    { icon: "✅", title: "Two-tap logging", desc: "Save what you did when you're done — or skip, the workout still counts. See your week, your month, every session you've ever done." },
    { icon: "🌱", title: "Habits & goals, optional", desc: "Build a daily streak or chase a long-term number if you want. Or don't. They live in their own tab and stay out of your way." },
    { icon: "🆓", title: "Free. Forever.", desc: "No subscription, no \"premium\" tier, no paywall mid-workout. Optional banner ads pay the bills." },
    { icon: "🔒", title: "Your data, your choice", desc: "Anonymous analytics are opt-in. Export everything as JSON or CSV anytime. No lock-in, no ad tracking." },
  ];

  const steps = [
    { num: "1", title: "Pick a workout", desc: "Browse the library or build your own with a two-step wizard." },
    { num: "2", title: "Press start", desc: "We handle the clock. You handle the moving." },
    { num: "3", title: "Log it. Or don't.", desc: "Two taps to save — or skip. Your call." },
  ];

  const screens = [
    { src: "/screenshots/screen1.png", alt: "Find a workout", rotate: -4, y: 20 },
    { src: "/screenshots/screen2.png", alt: "Workout library", rotate: -1.5, y: 0 },
    { src: "/screenshots/screen3.png", alt: "Timer running", rotate: 1.5, y: 0 },
    { src: "/screenshots/screen4.png", alt: "Habits, optional", rotate: 4, y: 20 },
  ];

  return (
    <div style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", background: "#000000", color: "#FFFFFF", lineHeight: 1.6, minHeight: "100vh" }}>

      {/* Hero */}
      <section style={{ textAlign: "center", padding: "72px 20px 60px", background: "radial-gradient(ellipse 80% 50% at 50% 0%, #1a1040 0%, #000000 70%)" }}>
        <img
          src="/app-icon.png"
          alt="Bedrély"
          style={{ width: 88, height: 88, marginBottom: 20, display: "inline-block", mixBlendMode: "lighten" }}
        />
        <h1 style={{ fontSize: "clamp(36px, 7vw, 56px)", fontWeight: 900, letterSpacing: 5, margin: "0 0 8px" }}>
          BEDRÉLY
        </h1>
        <p style={{ fontSize: 16, color: "#777777", letterSpacing: 3, textTransform: "uppercase", marginBottom: 32, marginTop: 24 }}>
          Simple Workouts
        </p>
        <h2 style={{ fontSize: "clamp(22px, 3.5vw, 32px)", fontWeight: 700, margin: "0 auto 16px", maxWidth: 560, lineHeight: 1.3 }}>
          Find a workout.<br />Press start.
        </h2>
        <p style={{ fontSize: "clamp(15px, 2vw, 18px)", color: "#AAAAAA", maxWidth: 540, margin: "0 auto 40px" }}>
          The simple way to move. Workout finder, built-in timer, and a two-tap log — all in one place. No gym, no jargon, no pressure.
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 14 }}>
          <AppStoreBadge />
          <GooglePlayBadge />
        </div>
        <div style={{ marginTop: 22 }}>
          <Link
            to="/preview"
            style={{ color: "#a5a8ff", textDecoration: "none", fontSize: 14, fontWeight: 500, letterSpacing: 0.3 }}
            onMouseEnter={e => { e.currentTarget.style.color = "#ffffff"; }}
            onMouseLeave={e => { e.currentTarget.style.color = "#a5a8ff"; }}
          >
            Or browse workouts in your browser →
          </Link>
        </div>
      </section>

      {/* Phone Showcase */}
      <section style={{ padding: "80px 0 60px", background: "linear-gradient(180deg, #000000 0%, #0d0d1a 50%, #000000 100%)", overflow: "hidden" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "0 20px" }}>
          <p style={{ textAlign: "center", fontSize: 13, fontWeight: 600, letterSpacing: 3, color: "#6366f1", textTransform: "uppercase", marginBottom: 16 }}>
            A quick look
          </p>
          <h2 style={{ textAlign: "center", fontSize: "clamp(24px, 4vw, 36px)", fontWeight: 700, marginBottom: 12 }}>
            Three apps in one
          </h2>
          <p style={{ textAlign: "center", color: "#888888", fontSize: 16, maxWidth: 540, margin: "0 auto 60px" }}>
            Workout finder, timer, and log — together in one free app. No subscription. No premium tier.
          </p>
          {/* Phones row */}
          <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
            gap: 20,
            overflow: "hidden",
            paddingBottom: 20,
            paddingTop: 20,
          }}>
            {screens.map((s) => (
              <PhoneMockup key={s.src} src={s.src} alt={s.alt} rotate={s.rotate} translateY={s.y} />
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section style={{ padding: "80px 0" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "0 20px" }}>
          <p style={{ textAlign: "center", fontSize: 13, fontWeight: 600, letterSpacing: 3, color: "#6366f1", textTransform: "uppercase", marginBottom: 16 }}>
            What's inside
          </p>
          <h2 style={{ textAlign: "center", fontSize: "clamp(24px, 4vw, 36px)", fontWeight: 700, marginBottom: 60 }}>
            Built around showing up
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 24 }}>
            {features.map((f) => (
              <div
                key={f.title}
                style={{
                  background: "#0f0f0f",
                  border: "1px solid #222222",
                  borderRadius: 20,
                  padding: 36,
                  transition: "transform 0.2s, border-color 0.2s, box-shadow 0.2s",
                }}
                onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.borderColor = "#6366f1"; e.currentTarget.style.boxShadow = "0 12px 40px rgba(99,102,241,0.15)"; }}
                onMouseLeave={e => { e.currentTarget.style.transform = ""; e.currentTarget.style.borderColor = "#222222"; e.currentTarget.style.boxShadow = ""; }}
              >
                <div style={{ fontSize: 44, marginBottom: 16 }}>{f.icon}</div>
                <h3 style={{ fontSize: 20, fontWeight: 700, marginBottom: 10 }}>{f.title}</h3>
                <p style={{ color: "#888888", fontSize: 15, lineHeight: 1.6, margin: 0 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How it works */}
      <section style={{ padding: "80px 0", background: "#060606" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "0 20px" }}>
          <p style={{ textAlign: "center", fontSize: 13, fontWeight: 600, letterSpacing: 3, color: "#6366f1", textTransform: "uppercase", marginBottom: 16 }}>
            How it works
          </p>
          <h2 style={{ textAlign: "center", fontSize: "clamp(24px, 4vw, 36px)", fontWeight: 700, marginBottom: 60 }}>
            Open. Pick. Move.
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 20, maxWidth: 920, margin: "0 auto" }}>
            {steps.map((s) => (
              <div
                key={s.num}
                style={{
                  background: "#0f0f0f",
                  border: "1.5px solid #1e1e1e",
                  borderRadius: 20,
                  padding: "32px 28px",
                  textAlign: "left",
                  transition: "all 0.2s",
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = "#6366f1"; e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.background = "#12121f"; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = "#1e1e1e"; e.currentTarget.style.transform = ""; e.currentTarget.style.background = "#0f0f0f"; }}
              >
                <div style={{
                  width: 44,
                  height: 44,
                  borderRadius: 22,
                  background: "rgba(99,102,241,0.15)",
                  color: "#a5a8ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 800,
                  fontSize: 18,
                  marginBottom: 18,
                }}>
                  {s.num}
                </div>
                <h3 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>{s.title}</h3>
                <p style={{ color: "#888888", fontSize: 15, lineHeight: 1.6, margin: 0 }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section style={{ padding: "100px 20px", textAlign: "center", background: "radial-gradient(ellipse 70% 60% at 50% 100%, #1a1040 0%, #000000 70%)" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}>
          <img
            src="/app-icon.png"
            alt="Bedrely"
            style={{ width: 80, height: 80, display: "block", mixBlendMode: "lighten" }}
          />
        </div>
        <h2 style={{ fontSize: "clamp(24px, 4vw, 36px)", fontWeight: 700, marginBottom: 14 }}>
          A simple place to move.
        </h2>
        <p style={{ color: "#888888", marginBottom: 40, fontSize: 18, maxWidth: 460, margin: "0 auto 40px" }}>
          Free, forever. Move at your own pace.
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 14 }}>
          <AppStoreBadge />
          <GooglePlayBadge />
        </div>
        <div style={{ marginTop: 22 }}>
          <Link
            to="/preview"
            style={{ color: "#a5a8ff", textDecoration: "none", fontSize: 14, fontWeight: 500, letterSpacing: 0.3 }}
            onMouseEnter={e => { e.currentTarget.style.color = "#ffffff"; }}
            onMouseLeave={e => { e.currentTarget.style.color = "#a5a8ff"; }}
          >
            Or browse workouts in your browser →
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ padding: "40px 20px", textAlign: "center", borderTop: "1px solid #1a1a1a" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div style={{ marginBottom: 14 }}>
            <Link to="/privacy" style={{ color: "#555555", textDecoration: "none", margin: "0 20px", fontSize: 14, transition: "color 0.2s" }}
              onMouseEnter={e => e.currentTarget.style.color = "#FFFFFF"}
              onMouseLeave={e => e.currentTarget.style.color = "#555555"}
            >
              Privacy Policy
            </Link>
            <button onClick={signInWithGoogle} style={{ color: "#555555", background: "none", border: "none", cursor: "pointer", margin: "0 20px", fontSize: 14, transition: "color 0.2s" }}
              onMouseEnter={e => e.currentTarget.style.color = "#FFFFFF"}
              onMouseLeave={e => e.currentTarget.style.color = "#555555"}
            >
              Sign In (Web)
            </button>
            <a href="mailto:support@bedrely.app" style={{ color: "#555555", textDecoration: "none", margin: "0 20px", fontSize: 14, transition: "color 0.2s" }}
              onMouseEnter={e => e.currentTarget.style.color = "#FFFFFF"}
              onMouseLeave={e => e.currentTarget.style.color = "#555555"}
            >
              Contact
            </a>
          </div>
          <p style={{ color: "#333333", fontSize: 13, margin: 0 }}>
            &copy; 2026 Bedrely. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
